import React from 'react';

import useLayout from '@/hooks/layout/useLayout';
import {twx} from '@/utils/tailwindUtils';

import useModalSwipeClose from '../hooks/useModalSwipeClose';
import PopupRaw from '../PopupRaw';
import styles from './PopupStickedWithSwipeCloseAnimated.module.scss';

const PopupStickedWithSwipeCloseAnimated = ({
    className,
    overlayClassName,
    swipeAreaClassName,
    children,
    onClose,
    isCloseVisible,
    isSwipeDashVisible = true,
    isOpen = true,
    onRequestClose,
    shouldCloseOnSwipeDown,
    onAfterClose,
    ...rest
}) => {
    const {onTouchMove, onTouchStart} = useModalSwipeClose(onRequestClose ?? onClose, shouldCloseOnSwipeDown);
    const {isTabletAndDesktop} = useLayout();

    return (
        <PopupRaw
            className={twx(
                'bottom-0 left-auto right-0 flex h-fit flex-col p-0 ml:bottom-auto ml:left-1/2 ml:right-auto ml:top-1/2 ml:-translate-x-1/2 ml:-translate-y-1/2 ml:transform',
                className
            )}
            overlayClassName={twx(styles.PopupStickedWithSwipeCloseAnimated, overlayClassName)}
            closeTimeoutMS={isTabletAndDesktop ? 0 : 300}
            onClose={onRequestClose ?? onClose}
            isOpen={isOpen}
            isCloseVisible={isCloseVisible}
            onAfterClose={onAfterClose}
            {...rest}
        >
            <div className={twx('py-6', swipeAreaClassName)} onTouchMove={onTouchMove} onTouchStart={onTouchStart}>
                {isSwipeDashVisible && <div className='mx-auto h-1 w-8 rounded-2xl bg-primary-tins-slate' />}
            </div>
            {children}
        </PopupRaw>
    );
};

export default PopupStickedWithSwipeCloseAnimated;
